export function formatActivitySummary(completedCount: number, cancelledCount: number): string[] {
    return [
        `${completedCount} completed ${completedCount === 1 ? 'session' : 'sessions'}`,
        `${cancelledCount} ${cancelledCount === 1 ? 'cancellation' : 'cancellations'}`,
    ];
}
